/* src/app/admin-dashboard/company-sites/company-sites-list/company-sites-list.component.css */
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 20px;
  width: 100%;
  height: 150px;
  display: inline-block;
  cursor: pointer;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.search-field {
  padding: 20px;
  width: 90%;
  max-width: 500px;
  margin-bottom: 11px;
  padding-bottom: 0;
}
.alarm-list {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px 20px;
  padding-bottom: 8px;
  min-width: 220px;
  transition: max-height 0.2s, padding 0.2s;
}
.alarm-list.collapsed {
  max-height: 40px;
  padding: 4px 20px;
  overflow: hidden;
}
.alarm-toggle {
  cursor: pointer;
  font-size: 24px !important;
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1100;
}
.alarm-toggle mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}
.alarm-list .warning {
  color: #ff9800;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.alarm-list .fault {
  color: #f44336;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.alarm-list mat-icon {
  margin-right: 8px;
}
.alarm-summary {
  font-size: 15px;
  margin-bottom: 8px;
  color: #333;
}
.alarm-system-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
  margin-right: 8px;
}
.alarm-system-link:hover {
  color: #1565c0;
}
.alarm-message-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.alarm-system-title {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  margin-left: 0;
  display: block;
}
.blinking {
  animation: blinkingText 1s infinite;
}
@keyframes blinkingText {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/*# sourceMappingURL=company-sites-list.component.css.map */
